import React from "react";
import { Box, ButtonProps, ModalProps } from "@mui/material";
import TkButton from "../../atoms/TkButton";
import TkModal from "../../atoms/TkModal";
import { TkModalProps } from "../../../type/componentsType/TkModal";
import { TkButtonProps } from "../../../type/componentsType/TkButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import "./_style.scss";
import TkLabelText from "../../atoms/TkLabelText";

/**
 * ボタン付きモーダル部品
 * TkModalButtonコンポーネントは、マテリアルUIのButtonコンポーネントを拡張したものです。
 * @param {TkModalProps} props - TkModalPropsコンポーネントのプロパティ
 * @param {function} [props.onChange="function"] - モーダルを制御するイベント
 * @param {boolean} disabled trueで非活性　falseで活性
 * @param rest オプション onChange ...rest
 * @return TkModalButton ボタン付きモーダル部品
 */

export const TkModalButton: React.FC<
  TkModalProps & TkButtonProps & ModalProps & ButtonProps
> = (props) => {
  const {
    open,
    children,
    menu,
    handleSave,
    handleCloseModal,
    handleOpenModal,
    buttonlefttext,
    buttonrighttext,
    selectedNames,
    disabled,
  } = props;

  const handleSelectSave = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    handleSave && handleSave(event);
  };

  const handleClose = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    handleCloseModal && handleCloseModal(event);
  };
  const handleModalOpen = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    handleOpenModal && handleOpenModal(event);
  };

  return (
    <Box className="tkSelectFacilities">
      <TkButton
        sx={{ ml: "10px" }}
        variant="contained"
        onClick={handleModalOpen}
        size="small"
        disabled={disabled}
      >
        選択
      </TkButton>
      <TkLabelText
        sx={{ ml: 3 }}
        variant="standard"
        wantToSetValue={selectedNames}
        required
        InputProps={{ disableUnderline: true, readOnly: true }}
        fullWidth
        multiline
        disabled={disabled}
      />
      <TkModal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        data-testid="tkModalForTest"
      >
        <Box className="tkModalSecInSelectFacilities">
          <Box className="buttonSec">
            <Box></Box>

            <Box>
              <TkButton
                variant="contained"
                onClick={handleSelectSave}
                size="small"
              >
                {buttonlefttext}
              </TkButton>
              <TkButton ml onClick={handleClose} size="small">
                {buttonrighttext}
              </TkButton>
            </Box>
          </Box>

          <Box className="selectSec">
            <Box className="selectItem">
              <ExpandMoreIcon />
              <Typography>{menu}</Typography>
            </Box>
          </Box>
          <Box className="tkModalButtonChildren">{children}</Box>
        </Box>
      </TkModal>
    </Box>
  );
};

export default TkModalButton;
